import React from 'react';

const SvgSplit = props => (
  <svg width={12} height={12} {...props}>
    <path
      d="M12 2.212L9.788 0 7.577 2.212l.663.663 1.08-1.079V3.69c0 .684-.297 1.333-.814 1.782L6.668 7.064a3.36 3.36 0 00-.672.795 3.209 3.209 0 00-.66-.791L3.495 5.47a2.357 2.357 0 01-.813-1.782V1.796l1.079 1.08.663-.664L2.212 0 0 2.212l.663.663 1.08-1.079V3.69c0 .956.414 1.864 1.137 2.49l1.842 1.598a2.35 2.35 0 01.797 1.771v1.477h.938v-1.47c0-.678.301-1.328.826-1.782L9.12 6.18a3.295 3.295 0 001.137-2.491V1.796l1.08 1.08.663-.664z"
      fill="#046FE2"
    />
  </svg>
);

export default SvgSplit;
